import { NavLink } from 'react-router-dom'
import { NAV_ITEMS } from '../../config/nav'
import NavIcon from './NavIcon'

// Phone navigation. Fixed to the bottom because that is where a thumb reaches,
// and padded past the home indicator so the last row is never half-covered.
//
// The active tab is marked by a 2px rule along its top edge rather than a pill:
// it is the same hairline vocabulary the rest of the product uses, and it does
// not make the bar look like a fourth surface.
export default function BottomNav() {
  return (
    <nav
      aria-label="Primary"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-surface border-t border-hairline shadow-bar"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <ul className="flex">
        {NAV_ITEMS.map((item) => (
          <li key={item.key} className="flex-1">
            <NavLink
              to={item.path}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-1 min-h-[58px]
                 border-t-2 transition-colors duration-quick ease-out ${
                   isActive ? 'text-brand border-brand' : 'text-ink-3 border-transparent'
                 }`
              }
            >
              {({ isActive }) => (
                <>
                  <NavIcon d={item.icon} className="w-[21px] h-[21px]" />
                  <span className={`text-tab ${isActive ? 'font-bold' : 'font-semibold'}`}>
                    {item.label}
                  </span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}
